import api from "../../utils/Api";
import {
    CHECK_MSV_REQUEST,
    CHECK_MSV_SUCCESS,
    CHECK_MSV_ERROR,
} from "./CheckMSVTypes";

export const checkMSVRequest = () => {
    return {
        type: CHECK_MSV_REQUEST,
    };
};

export const checkMSVSuccess = (checkMSVDetails) => {
    return {
        type: CHECK_MSV_SUCCESS,
        payload: checkMSVDetails,
    };
};

export const checkMSVFailure = (error) => {
    return {
        type: CHECK_MSV_ERROR,
        payload: error,
    };
};

export const checkMSVDetails = (payload) => {

    const headers = {
        'Content-Type': 'application/json',
        Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
   

    return async (dispatch) => {
        dispatch(checkMSVRequest());
        try {
            const response = await api.post("relatedparty/msv/check", payload, {
                headers: headers,
            });
            const checkMSVData = response.data.data;
            dispatch(checkMSVSuccess(checkMSVData));
        } catch (error) {
            console.log("Redux error - ", error.response.data.message);
            const errorMsg = error.response.data.message;
            dispatch(checkMSVFailure(errorMsg));
        }
    };
};
